import { render, staticRenderFns } from "./customer-view-page.vue?vue&type=template&id=d3106d94&"
import script from "./customer-view-page.vue?vue&type=script&lang=js&"
export * from "./customer-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports